import { ChevronDown } from "lucide-react";
import { BrandText } from "./Shared";

// Native disclosure list: every answer is in the DOM (collapsed), so FAQPage schema built from the same items always matches the page text.
export function FaqList({ items, testId = "faq-list", itemTestId = "faq", className = "", size = "base", open = 0 }) {
  const qCls = size === "lg" ? "text-base sm:text-lg" : "text-base";
  return (
    <div className={`divide-y divide-separator border-y border-separator ${className}`} data-testid={testId}>
      {items.map(([q, a], i) => (
        <details key={q} className="group" open={open === "all" || i < open} data-testid={`${itemTestId}-${i}`}>
          <summary className={`flex cursor-pointer list-none items-start justify-between gap-4 py-5 text-left font-semibold ${qCls} [&::-webkit-details-marker]:hidden`}>
            <span><BrandText>{q}</BrandText></span>
            <ChevronDown className="mt-1 h-4 w-4 shrink-0 text-label2 transition-transform duration-200 group-open:rotate-180" aria-hidden="true" />
          </summary>
          <div className="pb-6 text-base leading-relaxed text-body">{a}</div>
        </details>
      ))}
    </div>
  );
}

export const toPairs = (items) => items.map((f) => (Array.isArray(f) ? f : [f.q, f.a]));
